import { Box,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Typography,
  Divider } from '@mui/material';
import { validateNotNullOrUndefined } from '@weft/utils';
import { useNetSuiteUsers } from 'apps/app/src/hooks/requests/use-net-suite';
import React, { useState } from 'react';

type SelectNetSuiteUsersProps = {
  onSubsidiarySelect: (selectedSubsidiary: string) => void;
  erpId: string;
};

export const SelectNetSuiteUsers: React.FC<SelectNetSuiteUsersProps> = ({
  onSubsidiarySelect,
  erpId,
}) => {
  const netSuiteUsers = useNetSuiteUsers(erpId, {
    suspense: true,
    onSuccess: ({ subsidiaries }) => {
      onSubsidiarySelect(subsidiaries[0].id);
    },
  });
  validateNotNullOrUndefined(netSuiteUsers, 'NetSuite users data is required');
  const { data: { subsidiaries = [] } = {} } = netSuiteUsers;
  const [selectedSubsidiary, setSelectedSubsidiary] = useState<string | null>();

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const subsidiaryId = event.target.value;
    setSelectedSubsidiary(subsidiaryId);
    onSubsidiarySelect(subsidiaryId);
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FormControl sx={{ m: 2 }}>
          <>
            <FormLabel
              sx={{
                '&.MuiFormLabel-root': {
                  color: '#000000c4',
                  fontWeight: '100px',
                },
              }}
            >
              Related subsidiaries
            </FormLabel>
            <RadioGroup
              row
              value={selectedSubsidiary}
              onClick={(event) => event.stopPropagation()}
              onChange={handleRadioChange}
            >
              {subsidiaries.map((subsidiary) => (
                <FormControlLabel
                  key={subsidiary.id}
                  value={subsidiary.id}
                  control={<Radio size="small" />}
                  label={
                    <Typography
                      style={{ fontSize: '0.875rem', color: '#000000c4' }}
                    >
                      {subsidiary.name}
                    </Typography>
                  }
                />
              ))}
            </RadioGroup>
          </>
        </FormControl>
      </Box>
      <Divider sx={{ marginBottom: '16px' }} />
    </>
  );
};
